import { connect } from 'react-redux';
import YearSlider from './YearSlider';

import { setYearSliderChange } from '../../../../common/settings/actions';

const mapStateToProps = state => ({
    doughnutSlider: state.settings.doughnutSlider,
    horizonLength: state.settings.horizonLength,
    setYearSliderChange,
});

const combinedActions = {
    setYearSliderChange,
};

export default connect(mapStateToProps, combinedActions)(YearSlider);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/YearSlider/index.js